import React from 'react';
import clsx from 'clsx';
import styles from './PageHeader.css';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
    children: React.ReactNode;
}

const PageHeaderRight = ({ children, className, ...others }: Props) => {
    return (
        <div className={clsx(styles.rightContainer, className)} {...others}>
            {children}
        </div>
    );
};

export default PageHeaderRight;
